import type { SimpleKeyboard } from 'react-simple-keyboard';
import { SPECIAL_KEYS } from '../utils/constants';

const shiftLock = (keyboard: SimpleKeyboard) => {
  keyboard.registerModule('shiftLock', (module: any) => {
    module.fn = { handleButtonClicked: keyboard.handleButtonClicked };

    keyboard.handleButtonClicked = (...args) => {
      const [button] = args;
      if (button === SPECIAL_KEYS.SHIFT) {
        const { layoutName } = keyboard.getOptions();
        keyboard.setOptions({ layoutName: layoutName === 'default' ? 'shift' : 'default' });
      }
      module.fn.handleButtonClicked.call(keyboard, ...args);
    };
  });
};

export default shiftLock;
